import { render, staticRenderFns } from "./PortcallsForm.vue?vue&type=template&id=35bb8f18"
import script from "./PortcallsForm.vue?vue&type=script&lang=js"
export * from "./PortcallsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports